$(function () {
	/**
	 * ギャラリーのモーダル
	 * 画像はaタグのdata-srcが反映される
	 * テキストはaタグ下の.text要素が反映されます
	 */
	$('.js-gallery_modal_btn').click(function () {
		var img = $(this).attr('data-src');
		var text = $(this).text()
		var target = $(this).attr('href');
		$(target).find('.p-gallery-modal__image img').attr('src', img);
		$(target).find('.p-gallery-modal__text').text(text);
		$(target).addClass('is-show');
		return false;
	})

	/**
	 * タブ切り替え
	 */
	var tab = $('.js-tab');
	tab.slick({
		dots: false,
		infinite: false,
		fade: true,
		arrows: false,
		adaptiveHeight: true,
		swipe: false,
		touchMove: false,
		swipeToSlide: false,
	});
	tab.on('afterChange', function () {
		// console.log(event)
		// console.log(slick)
		// console.log(currentSlide)
		var current = $('.slick-active').find('.p-tab-items__item').attr('data-slide')
		
		$('.js-tabBtns a').removeClass('is-current')
		$('.js-tabBtns a').eq(current).addClass('is-current')
	});
	$('.js-slickGoTo').click(function () {
		var index = $(this).attr('href');
		tab.slick('slickGoTo', index);
		return false;
	})
	$('.js-slickGoToAccess').click(function () {
		var index = $(this).attr('href');
		tab.slick('slickGoTo', index);
		var target = $('#access');
		var position = target.offset().top;
		$("html, body").animate({ scrollTop: position }, 500, "swing");

		return false;
	})
})